export const GIFTING_HOME_DEEPLINK =
    "swiggy://discovery?screen_type=landing&layout_type=GIFTING&tags=layout_gifting_hp&businessLine=BUSINESS_LINE_GIFTING&excludeTab=false";
